import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/home';
import About from './components/about';
import Projects from './components/projects';
import Privacy from './components/privacy';

function App() {
  const [accessToken, setAccessToken] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check for access token in URL hash (OAuth callback)
    const hash = window.location.hash;
    if (hash) {
      const params = new URLSearchParams(hash.substring(1));
      const token = params.get('access_token');

      if (token) {
        setAccessToken(token);
        setIsLoggedIn(true);
        localStorage.setItem('spotify_access_token', token);
        // Clean up URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    } else {
      // Check if token exists in localStorage
      const storedToken = localStorage.getItem('spotify_access_token');
      if (storedToken) {
        setAccessToken(storedToken);
        setIsLoggedIn(true);
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('spotify_access_token');
    setAccessToken(null);
    setIsLoggedIn(false);
  };

  const handleSpotifyLogin = () => {
    const clientId = process.env.REACT_APP_SPOTIFY_CLIENT_ID || 'YOUR_SPOTIFY_CLIENT_ID';
    const redirectUri = process.env.REACT_APP_REDIRECT_URI || window.location.origin;
    const scopes = [
      'user-read-private',
      'user-read-email',
      'user-top-read',
      'playlist-modify-public',
      'playlist-modify-private'
    ];

    const authUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scopes.join(' '))}`;

    window.location.href = authUrl;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} accessToken={accessToken} setAccessToken={setAccessToken} onLogout={handleLogout} />} />
        <Route path="/about" element={<About isLoggedIn={isLoggedIn} onLogout={handleLogout} onLogin={handleSpotifyLogin} />} />
        <Route path="/projects" element={<Projects isLoggedIn={isLoggedIn} onLogout={handleLogout} onLogin={handleSpotifyLogin} />} />
        <Route path="/privacy" element={<Privacy isLoggedIn={isLoggedIn} onLogout={handleLogout} onLogin={handleSpotifyLogin} />} />
      </Routes>
    </Router>
  );
}

export default App;
